<mat-card flex="100">
  <mat-card-title class="float-left">Add {{ airCarrier?.abbreviation }} Pilot</mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <ng-container *ngIf="errors$ | async as errors">
      <div class="command-error-message">
        Errors found:
        <ul>
          <li *ngFor="let error of errors">
            {{ error.message }}
          </li>
        </ul>
      </div>
    </ng-container>
    <fl-pilot-form></fl-pilot-form>
    <div fxLayout fxLayoutGap="10px">
      <button
        mat-raised-button
        (click)="add(); clicked = true"
        [disabled]="pilotFormCmp?.form.invalid || clicked"
      >
        Add
      </button>
      <a mat-button routerLink="..">Cancel</a>
    </div>
  </mat-card-content>
</mat-card>
